import { render, staticRenderFns } from "./InstitutionDoctors.vue?vue&type=template&id=0a256545"
import script from "./InstitutionDoctors.vue?vue&type=script&lang=js"
export * from "./InstitutionDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports